module.exports = __webpack_public_path__ + "img/floating-menu_burger.a928dcc5.svg";